import dvaModelExtend from 'dva-model-extend';

import { bindServices } from '@/services/api';
import { toPaginate, getFiltersGlobalFilters } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';
import { createCrudModel } from '@/utils/core/dva';

import { ENTITY_NAME, FETCH_ROUTE, MODEL_NAME } from './constants';

const api = bindServices(MODEL_NAME);
const fetchRoute = FETCH_ROUTE;
const fetchParams = 'ReportToken';

const initialPagination = { page: 1, count: 0, totalPages: 0 };

const _model = createCrudModel({
  namespace: MODEL_NAME,
  fetchRoute,
  fetchParams,
  entityName: ENTITY_NAME,
  api,
  features: { import: false, bulkActions: true },
  state: {
    openTokenTraceDrawer: false,
    tokenTraceList: [],
    paginationTokenTrace: { page: 1, count: 0, totalPages: 0 },
    orderByReportToken: '',
    tokenTraceSearchTable: '',
    openTokenTraceDetail: false,
    idTrace: null,
    tokenModal: { visible: false, value: '' },
  },
  effects: {
    *toggleTokenTraceDrawer({ payload }, { put }) {
      yield put({
        type: 'queryToggleTokenTraceDrawer',
        payload,
      });
    },

    *fetchTokenTraceList({ payload }, { call, put }) {
      try {
        const filterStr = payload.filter
          ? getFiltersGlobalFilters({ tokenTraces: payload.filter }, 'tokenTraces')
          : null;
        const params = {
          route: `reportToken/traces/${payload.idReportToken}`,
          page: payload.page,
          limit: payload.limit,
          search: payload.search,
          orderBy: payload.orderBy,
          ...(filterStr && { filter: filterStr }),
          ...CoreQueries.ManageTokenTrace.paged,
        };
        const response = yield call(api.getAll, params);
        yield put({
          type: 'queryTokenTraceList',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
          },
        });
      } catch (error) {
        if (error?.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: { visible: true, type: 'error', message: error.message },
          });
        }
      }
    },

    *toggleTokenTraceDetail({ payload }, { put }) {
      yield put({
        type: 'queryToggleTokenTraceDetail',
        payload,
      });
    },

    *setOrderTokenTrace({ payload }, { put }) {
      yield put({
        type: 'querySetOrderTokenTrace',
        payload,
      });
    },

    *hideAllForms(_, { put }) {
      yield put({ type: 'hideForms' });
    },
  },
  reducers: {
    showTokenModal(state, { payload }) {
      return {
        ...state,
        tokenModal: { visible: true, value: payload?.value || '' },
      };
    },

    hideTokenModal(state) {
      return {
        ...state,
        tokenModal: { visible: false, value: '' },
      };
    },

    queryToggleTokenTraceDrawer(state, { payload }) {
      const base = { ...state, openTokenTraceDrawer: payload.state, id: payload.id };
      if (!payload.state) {
        return {
          ...base,
          tokenTraceList: [],
          paginationTokenTrace: { ...initialPagination },
          orderByReportToken: '',
          tokenTraceSearchTable: '',
          openTokenTraceDetail: false,
          idTrace: null,
        };
      }
      return { ...base, orderByReportToken: 'created desc', tokenTraceSearchTable: '' };
    },

    queryTokenTraceList(state, { payload }) {
      return {
        ...state,
        tokenTraceList: payload.items || [],
        paginationTokenTrace: {
          ...state.paginationTokenTrace,
          ...toPaginate(payload),
        },
      };
    },

    setTokenTraceSearchTable(state, { payload }) {
      return {
        ...state,
        tokenTraceSearchTable: payload ?? '',
      };
    },

    clearTokenTraceList(state) {
      return {
        ...state,
        tokenTraceList: [],
        paginationTokenTrace: { ...initialPagination },
      };
    },

    querySetOrderTokenTrace(state, { payload }) {
      return {
        ...state,
        orderByReportToken: payload.value,
      };
    },

    queryToggleTokenTraceDetail(state, { payload }) {
      return {
        ...state,
        openTokenTraceDetail: payload.state,
        idTrace: payload.state ? payload.idTrace : null,
        selectedItemTrace: payload.state && payload.item ? payload.item : null,
      };
    },

    hideForms(state) {
      return {
        ...state,
        showForm: false,
        item: null,
        detail: false,
        id: null,
      };
    },
  },
});

export default dvaModelExtend(_model, {
  namespace: MODEL_NAME,
  reducers: {
    resetStateReducer() {
      return { ..._model.state };
    },
  },
});
